'use strict';

const Backbone = require('backbone');

class BaseCollection extends Backbone.Collection {
  constructor() {
    super(...arguments);
    this._meta = {};
    this.on('request', this.loading);
    this.on('sync', this.loaded);
    this.on('error', this.loaded);
  }

  meta(prop, value) {
    if (value !== undefined) {
      this._meta[prop] = value;
    }
    return this._meta[prop];
  }

  loading() {
    return this.meta('loaded', false);
  }

  loaded() {
    return this.meta('loaded', true);
  }

  isLoading() {
    return this.meta('loaded') === false;
  }

  isLoaded() {
    return this.meta('loaded') === true;
  }
}
module.exports = BaseCollection;
